<template>
    <!-- 新增表格数据的dialog -->
    <div>
        <el-dialog :visible.sync="updateDialogVisible" :close-on-click-modal="false" width="50%" 
        :before-close="handleToClose" title="编辑服饰">
            <el-form ref="editForm" :model="editForm" :rules="rules"  label-width="80px" label-position="center">
                <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
                    <el-col :span="12">
                        <div class="grid-content bg-purple">
                            <el-form-item label="服饰款号" prop="clothesName">
                                <el-input v-model="editForm.clothesName" placeholder="请输入服饰款号"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="grid-content bg-purple">
                            <el-form-item label="品牌商" prop="factoryDictionary">
                                <el-select v-model="editForm.clothesFactory" placeholder="请选择品牌商">
                                    <el-option
                                    v-for="item in clothesDictionary.factoryDictionary"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row type="flex" class="row-bg"  justify="space-around"  :gutter="20">
                    <el-col :span="12">
                        <div class="grid-content bg-purple">
                            <el-form-item label="服装款式" prop="typeDictionary">
                                <el-select v-model="editForm.clothesType" placeholder="请选择服装款式">
                                    <el-option
                                    v-for="item in clothesDictionary.typeDictionary"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="grid-content bg-purple">
                            <el-form-item label="服装材料" prop="clothesMaterial">
                                 <el-select v-model="editForm.clothesMaterial" placeholder="请选择或输入服装材料" filterable clearable @blur="getCurVal">
                                    <el-option
                                    v-for="item in clothesDictionary.materialDictionary"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
                    <!-- <el-col :span="12">
                        <div class="grid-content bg-purple">
                            <el-form-item label="进价" prop="clothesPurchasePrice">
                                <el-input v-model="editForm.clothesPurchasePrice" placeholder="请输入进价"></el-input>
                            </el-form-item>
                        </div>
                    </el-col> -->
                     <el-col :span="12">
                        <div class="grid-content bg-purple">
                            <el-form-item label="批发价" prop="clothesWholesalePrice">
                                <el-input v-model="editForm.clothesWholesalePrice" placeholder="请输入批发价"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="grid-content bg-purple">
                            <el-form-item label="零售价" prop="clothesRetailPrice">
                                <el-input v-model="editForm.clothesRetailPrice" placeholder="请输入零售价"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
               <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
                    <el-col :span="24" style="display:flex;flex-direction:row">
                        <div class="grid-content bg-purple">
                            <el-form-item label="专区" prop="clothesSeason">
                                <el-select v-model="editForm.clothesSeason" placeholder="请选择服饰专区" @change="selectSeason">
                                    <el-option
                                    v-for="item in clothesSeason"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div>
                             <el-form-item label=">>>>>" prop="clothesSubZone">
                                <el-select v-model="editForm.clothesSubZone" placeholder="请选择子专区">
                                    <el-option
                                    v-for="item in clothesZone"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                             </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
                    <el-col :span="2">
                        <div class="grid-content bg-purple">
                            <el-form-item label="尺码" prop="sizeDictionary">
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="grid-content bg-purple" style="margin-bottom:20px">
                            <el-checkbox-group v-model="clothesSizeIds" size="small">
                                <el-checkbox-button v-for="item in clothesDictionary.sizeDictionary" :label="item.value" 
                                :key="item.value">{{item.label}}</el-checkbox-button>
                            </el-checkbox-group>
                        </div>
                    </el-col>
                </el-row>
                <el-row type="flex" justify="space-around" :gutter="20" v-for="(item, index) in editForm.clothesColor" :key="index">
                    <el-col :span="13">
                        <div class="grid-content bg-purple">
                            <el-form-item label="颜色" :prop="'clothesColor.'+index+'.color'" :rules="{ required: true, message: '请输入服装颜色', trigger: 'blur' }">
                                <el-input v-model="item.color" placeholder="请输入服装颜色"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="grid-content bg-purple">
                            <el-form-item label="服装图片" :prop="'clothesColor.'+index+'.clothesPictureUrl'">
                                <el-upload
                                    class="avatar-uploader"
                                    action
                                    :show-file-list="false"
                                    :on-success="handleAvatarSuccess"
                                    :http-request="(param) => handleHttpRequest(param,index)"
                                    :before-upload="beforeAvatarUpload">
                                    <img v-if="item.clothesPictureUrl" :src="item.clothesPictureUrl" class="avatar" />
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                            
                        </div>
                    </el-col>
                    <el-button v-if="index == 0" style="height:30px" type="primary" icon="el-icon-plus" circle  @click="doPushClothesColor()"></el-button>
                    <el-button v-else style="height:30px" type="danger" icon="el-icon-minus" circle  @click="doUnPushClothesColor(index)"></el-button>
                </el-row>

                <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
                     <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="详情图片" prop="clothesDetailPics">
                                <el-upload
                                    action=""
                                    multiple
                                    ref="detailPic"
                                    :file-list="detailFileList"
                                    list-type="picture-card"
                                    :http-request="(param) => handleDetailPicRequest(param)"
                                    :on-preview="handlePictureCardPreview"
                                    :on-remove="handleRemove">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                                <el-dialog :visible.sync="dialogVisible">
                                    <img width="100%" :src="dialogImageUrl" alt="">
                                </el-dialog>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <div class="dialog-footer">
                    <el-button type="info" @click="handleToClose">取 消</el-button>
                    <el-button type="primary" @click="submitForm('editForm')">保存</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            imageUrl: '',
            uploadUrl: 'file/upload', //图片上传地址
            updateDialogVisible: false,
            dialogImageUrl: '',
            dialogVisible: false,
            clothesPicUid: [],//详情图片fileId数组
            detailFileList: [],
            editForm: {
                id: '', //ID
                clothesName: '', //吊牌款号
                clothesType: '', //服饰类别
                clothesFactory: '', //服饰品牌商
                clothesMaterial: '', //服装材质
                clothesPurchasePrice: '', //进价
                clothesWholesalePrice: '', //批发价
                clothesRetailPrice: '', //零售价
                clothesSeason: '', //专区
                clothesSubZone: '',//子专区
                clothesColor: [
                    {
                        color: '', //颜色
                        clothesPictureId: '',//服装图片ID
                        clothesPictureUrl: '', //服装图片路径 
                    }
                ],
                clothesDetailPics: [] //服装详情图片
            },
            clothesSizeIds: [],//尺码
            clothesZone: [],
            clothesSeason: [
                {
                    value: 1,
                    label: '春秋专区',
                    children: [
                        {value: 1,label: '春秋套装'},
                        {value: 2,label: '针织卫衣'},
                        {value: 3,label: '春秋裤类'},
                        {value: 4,label: '户外风衣'},
                        {value: 5,label: '抓绒衣'}
                    ]
                },
                {
                    value: 2,
                    label: '夏季专区',
                    children: [
                        {value: 1,label: '夏季套装'},
                        {value: 2,label: '圆领短袖'},
                        {value: 6,label: '翻领短袖'},
                        {value: 3,label: '夏季裤类'},
                        {value: 4,label: '防晒服'},
                        {value: 5,label: '短裤专区'}
                    ]
                },
                {
                    value: 3,
                    label: '冬季专区',
                    children: [
                        {value: 1,label: '冬季套装'},
                        {value: 2,label: '冲锋衣'},
                        {value: 3,label: '加绒卫衣'},
                        {value: 4,label: '冬季裤类'},
                        {value: 5,label: '加绒风衣'},
                        {value: 6,label: '羽绒棉衣'}
                    ]
                },
                {
                    value: 4,
                    label: '比赛运动区',
                    children: [
                        {value: 1,label: '篮球服'},
                        {value: 2,label: '足球服'},
                        {value: 3,label: '排球服'},
                        {value: 4,label: '田径服'},
                        {value: 5,label: '乒羽服'},
                        {value: 7,label: '裤裙区'},
                        {value: 8,label: '短袖PoLo衫'},
                        {value: 9,label: '体育用品'},
                        {value: 6,label: '运动健身区'}
                    ]
                },
                {
                    value: 5,
                    label: '团购专区',
                    children: [
                        {value: 1,label: '春秋团购'},
                        {value: 2,label: '夏季团购'},
                        {value: 3,label: '冬季团购'},
                        {value: 4,label: '出场服'},
                        {value: 5,label: '雪袍大衣'}
                    ]
                },
                {
                    value: 6,
                    label: '特价区',
                    children: [
                        {value: 1,label: '春秋特价'},
                        {value: 2,label: '夏季特价'},
                        {value: 3,label: '冬季特价'}
                    ]
                }
            ],
            rules: {
                clothesName: [
                    { required: true, message: '请输入服饰款号', trigger: 'blur' }
                ],
                clothesType: [
                    { required: true, message: '请选择服饰类别', trigger: 'change' }
                ],
                clothesFactory: [
                    { required: true, message: '请选择品牌商', trigger: 'change' }
                ],
                clothesMaterial: [
                    { required: true, message: '请输入服饰材料', trigger: 'blur' }
                ],
                clothesPurchasePrice: [
                    { required: true, message: '请输入服饰进价', trigger: 'blur' },
                    {
                        pattern: /^\d*(\.\d{1,2})?$/,
                        message: '只能输入整数或两位小数',
                        trigger: 'blur'
                    }
                    
                ],
                clothesWholesalePrice: [
                    { required: true, message: '请输入服饰批发价', trigger: 'blur' },
                    {
                        pattern: /^\d*(\.\d{1,2})?$/,
                        message: '只能输入整数或两位小数',
                        trigger: 'blur'
                    }
                ],
                clothesRetailPrice: [
                    { required: true, message: '请输入服饰零售价', trigger: 'blur' },
                    {
                        pattern: /^\d*(\.\d{1,2})?$/,
                        message: '只能输入整数或两位小数',
                        trigger: 'blur'
                    }
                ],
                clothesSeason: [
                    { required: true, message: '请选择服饰季节', trigger: 'change' }
                ]
            }
        }
    },
    props: ["clothesDictionary"],
    methods: {
        openDialog() {
            this.updateDialogVisible = true;
        },
         selectSeason(value) {
             this.editForm.clothesSubZone = ''
            this.clothesZone = this.clothesSeason[value - 1].children
        },
        submitForm() {
            let that = this;
            that.$refs.editForm.validate(valid => {
                if (valid) {
                    this.$axios
                        .post('manage/cloth/updateClothes', {
                            id: that.editForm.id, //ID
                            clothesName: that.editForm.clothesName, //吊牌款号
                            clothesType: that.editForm.clothesType, //服饰类别
                            clothesFactory: that.editForm.clothesFactory, //服饰品牌商
                            clothesMaterial: that.editForm.clothesMaterial, //服装材质
                            clothesPurchasePrice: that.editForm.clothesPurchasePrice, //进价
                            clothesWholesalePrice: that.editForm.clothesWholesalePrice, //批发价
                            clothesRetailPrice: that.editForm.clothesRetailPrice, //零售价
                            clothesSeason: that.editForm.clothesSeason, //专区
                            clothesSubZone: that.editForm.clothesSubZone,//子专区
                            clothesColor: that.editForm.clothesColor,
                            clothesSizeIds: that.clothesSizeIds,
                            clothesDetailPics: that.editForm.clothesDetailPics
                        })
                        .then(res => {
                            if (res.data.code == 0) {
                                //保存成功后 置空表单数据 关闭弹窗  刷新列表
                                that.$message.success('保存成功');
                                that.updateDialogVisible = false;
                                that.resetForm();
                                that.$parent.getClothesList();
                            } else {
                                that.$message.error(res.data.data);
                            }
                        });
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        async getClothesInfo(id){
            this.id = id;
            let that = this;
            const res = await that.$axios.post('manage/cloth/getClothesInfo', {
                id: id
            });
            if (res.data.code == 0) {
                that.editForm = res.data.data;
                that.updateDialogVisible = true;
                if(res.data.data.clothesColor.length == 0){
                    this.editForm.clothesColor = [
                        {
                            color: '', //颜色
                            clothesPictureId: '',//服装图片ID
                            clothesPictureUrl: '', //服装图片路径 
                        }
                    ]
                }
                this.clothesZone = this.clothesSeason[res.data.data.clothesSeason - 1].children
                
                //此处修改尺码选中数组
                this.clothesSizeIds = res.data.data.clothesSizeIds
                for(var i = 0; i < res.data.data.clothesDetailPics.length; i++){
                    this.detailFileList.push({
                        'uid': res.data.data.clothesDetailPics[i].id,
                        'url': res.data.data.clothesDetailPics[i].url
                    })
                    this.clothesPicUid.push(res.data.data.clothesDetailPics[i].id)
                }
            }
        },
        resetForm() {
            this.$refs.editForm.resetFields();
            this.editForm.clothesColor = [
                        {
                            color: '', //颜色
                            clothesPictureId: '',//服装图片ID
                            clothesPictureUrl: '', //服装图片路径 
                        }
                    ];
            this.detailFileList = [];
            this.dialogImageUrl = '';
            this.clothesPicUid = [];
            this.dialogVisible = false;
        },
        handleToClose() {
            let that = this;
            that.$confirm('确认放弃对当前页面信息的保存吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    that.updateDialogVisible = false;
                    this.resetForm();
                })
                .catch(() => {});
            // 重置表单
        },
        getCurVal(val) {
            this.editForm.clothesMaterial = val.target.value;
        },
        doPushClothesColor() {
            let obj =  {
                color: '', //颜色
                clothesPictureUrl: '', //服装图片路径 
            }
            this.editForm.clothesColor.push(obj)
        },
        doUnPushClothesColor(index) {
            this.editForm.clothesColor.splice(index,1)
        },
        handleAvatarSuccess(res, file) {
        },
        beforeAvatarUpload(file) { 
        },
        //上传事件
        async handleHttpRequest(param,index) {
            const formData = new FormData();
            formData.append('file', param.file);
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            const res = await this.$axios.post(this.uploadUrl, formData, config);
            if (res.data.code == 0) {
                this.editForm.clothesColor[index].clothesPictureUrl = res.data.data.url
                this.editForm.clothesColor[index].clothesPictureId = res.data.data.id
            } else {
                this.$message.error(res.data);
            }
        },

        async handleDetailPicRequest(param) {
            const formData = new FormData();
            formData.append('file', param.file);
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            const res = await this.$axios.post(this.uploadUrl, formData, config);
            if (res.data.code == 0) {
                this.editForm.clothesDetailPics.push(res.data.data)
                this.clothesPicUid.push(param.file.uid)
            } else {
                this.$message.error(res.data);
            }
        },
        handleRemove(file, fileList) {
            console.log(file,fileList)
            var newUidArr = [];
            for(var i = 0; i < this.clothesPicUid.length; i++) {
                if(this.clothesPicUid[i] == file.uid){
                    //删除对应图片
                    this.editForm.clothesDetailPics.splice(i, 1)
                }else{
                    newUidArr.push(this.clothesPicUid[i])
                }
            }
            console.log(this.editForm.clothesDetailPics)
            this.clothesPicUid = newUidArr;
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        }
    }
}
</script>

<style lang="less" scoped>
.dialog-footer {
    text-align: right;
}
.el-select {
    width: 100%;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
    border: 1px dashed #d9d9d9;
}
.avatar {
    width: 148px;
    height: 148px;
    display: block;
}
</style>
